import { ServiceConfig } from "./service-config.model";

export enum IncidentStatusCode {
  CREATED = 'CREATED',
  OPEN = 'OPEN',
  ONGOING = 'ONGOING',
  RESOLVED = 'RESOLVED',
  CLOSED = 'CLOSED'
}

export enum IncidentEnvironment {
  DEV02 = 'DEV02',
  INT = 'INT',
  DITR = 'DITR',
  UATR = 'UATR',
  UATM = 'UATM',
  PROD = 'PROD'
}

// Order in which incidents are displayed on the dashboard columns, validated by the PO (AZTGSA-13211)
export const INCIDENT_ENVIRONMENT_DISPLAY_ORDER: IncidentEnvironment[] = [
  IncidentEnvironment.PROD,
  IncidentEnvironment.UATM,
  IncidentEnvironment.UATR,
  IncidentEnvironment.DITR,
  IncidentEnvironment.INT,
  IncidentEnvironment.DEV02
];

export interface ImpactedApplication {
  applicationId: string;
  impactedFeatureIds?: string[];
  impactedFeatureNames?: string[];
}

export interface Incident {
  pagerDutyServiceId: string;
  pagerDutyIncidentId: string;
  jiraTicketKey?: string;
  serviceIntegrationManagementTicketId?: string;
  incidentStatusCode?: IncidentStatusCode;
  incidentDescription?: string;
  priorityCode?: string;
  incidentEnvironmentCode?: `${IncidentEnvironment}`;
  incidentCommunicationCounter?: number;
  impactedApplications?: ImpactedApplication[];
  incidentStartDateTime?: string;
  ongoingActionsDescription?: string;
  workaroundDescription?: string;
  technicalInformationDescripion?: string;
  rootCauseDescription?: string;
  impactedUserDescription?: string;
  incidentEndDateTime?: string;
  resolutionCommunicationSentDateTime?: string;
  carbonCopies?: string[];
  lastUpdateDateTime?: string;
  lastUpdatedby?: string;
}


// Extended incident with service details including applications and features
export interface EnrichedIncident extends Incident {
  service?: ServiceConfig;
}


export interface IncidentDisplay {
  pagerDutyIncidentId: string;
  applicationName: string;
  incidentEnvironmentCode?: `${IncidentEnvironment}`;
  priorityCode: string | undefined;
  incidentStartDateTime: string | undefined;
  incidentDescription: string | undefined;
  simTicketId: string | undefined;
  incidentCommunicationCounter: number | undefined;
  timeUntilRemoval?: string;
  lastUpdateDateTime?: string;
  lastUpdatedby?: string;
}
